import * as React from 'react';
import { IAdvantageClaimsType, IAdvantageClaimsTypeState } from './AdvantageClaimsTypes';
import { IChildrenProps } from 'types/children';
import { ClaimStateEnum } from 'enums/ClaimState';

export const AdvantageClaimsContext = React.createContext<IAdvantageClaimsTypeState | null>(null);

const AdvantageClaimsProvider: React.FC<IChildrenProps> = ({ children }): React.ReactElement => {
    const [stateAdvantageClaims, setStateAdvantageClaims] = React.useState<IAdvantageClaimsType>({
        reviewState: ClaimStateEnum.INACTIVE
    });
    const value: IAdvantageClaimsTypeState = {
        contextStateAdvantageClaims: stateAdvantageClaims,
        updateContextStateAdvantageClaims: setStateAdvantageClaims
    };

    return <AdvantageClaimsContext.Provider value={value}>{children}</AdvantageClaimsContext.Provider>;
};

export default AdvantageClaimsProvider;
